import * as dayjs from 'dayjs';

const _ = window._; // TODO: Replace with import once all services are being imported instead of using window.cirkulServices
const $ = window.$; // TEMPORARY. REMOVE JQUERY WHEN POSSIBLE.

console.log('[2024-10-14] business-intelligence init');

// TODO: Remove IIFE, export hook that returns reactive state and callable functions.
(() => {
  const MIGRATION_VERSION = 1; // Only needed during migration from MP to Zaius
  const BUSINESS_INTELLIGENCE_CUSTOMER_ID_LOCAL_VARIABLE = 'cirkul:bi:customer-id';
  const BUSINESS_INTELLIGENCE_DEFERRED_PROFILE_UPDATES_LOCAL_VARIABLE = 'cirkul:bi:deferred-profile-updates';
  const HAS_SUBSCRIPTION_LOCAL_VARIABLE = 'cirkul:has-subscription';

  const EVENT_KEYS = {
    ACCOUNT: {
      REGISTER: '/webstore/events/account/register',
      LOGIN: '/webstore/events/account/login',
      LOGOUT: '/webstore/events/account/logout',
      PASSWORD_CHANGED: '/webstore/events/account/password-changed',
      UPDATE: '/webstore/events/account/update',
      PRIVACY_POLICY_MESSAGE_SEEN: '/webstore/events/account/privacy-policy-message-seen',
    },
    LIST: {
      SUBSCRIBE: '/webstore/events/list/subscribe',
      FREE_SIP_CHOICE: '/webstore/events/list/free-sip-choice',
    },
    REWARDS: {
      REDEEM_TO_CART: '/webstore/events/rewards/redeem-to-cart',
      REDEEM_TO_SUBSCRIPTION: '/webstore/events/rewards/redeem-to-subscription',
    },
    SMS: {
      SUBSCRIBE: '/webstore/events/sms/subscribe',
      VERIFY: '/webstore/events/sms/verify',
      RESEND_VERIFICATION: '/webstore/events/sms/resend-verification',
    },
    PRODUCT: {
      DETAIL_VIEW: '/webstore/events/product/detail-view'
    },
    SOCIAL: {
      OUTBOUND_LINK_FOLLOW: '/webstore/events/social/outbound-link-follow'
    },
    SUBSCRIPTION: {
      CANCEL_BACKOUT: '/webstore/events/subscription/cancel-backout',
      CANCEL_CONFIRMED: '/webstore/events/subscription/cancel-confirmed',
      CANCEL_INITIATED: '/webstore/events/subscription/cancel-initiated',
      CANCEL_SAVE: '/webstore/events/subscription/cancel-save',
      CANCEL_DELAY_SAVE: '/webstore/events/subscription/cancel-delay-save',
      CHANGE_DATE: '/webstore/events/subscription/change-date',
      LINE_ITEM_MODIFICATION_RECURRING: '/webstore/events/subscription/line-item-modification-recurring',
      LINE_ITEM_MODIFICATION_ONETIME: '/webstore/events/subscription/line-item-modification-onetime',
      RESUMED: '/webstore/events/subscription/resumed',
      SCHEDULE_ACCELERATE: '/webstore/events/subscription/schedule-accelerate',
      SCHEDULE_DELAY: '/webstore/events/subscription/schedule-delay',
      SHIP_NOW_INITIATE: '/webstore/events/subscription/ship-now-initiate',
      SHIP_NOW_CONFIRM: '/webstore/events/subscription/ship-now-confirm',
      UPDATE_PAYMENT_METHOD: '/webstore/events/subscription/update-payment-method',
    },
  };
  const UNAUTHED_EVENT_KEYS = {
    TIKTOK: {
      ADD_TO_CART: '/webstore/events/tik-tok/add-to-cart',
      VIEW_CONTENT: '/webstore/events/tik-tok/view-content',
    },
  };
  const WAITLIST_KEYS = {
    CIRKUL_PLUS: {
      REGULAR: '/webstore/waitlist/cirkul-plus',
      PRIORITY: '/webstore/waitlist/cirkul-plus-priority',
    }
  }

  const PROFILE_UPDATE_ACTIONS = {
    DIRECT_SET: 'direct-set',
    SET: 'set',
    SET_ONCE: 'set-once',
    SET_UTM: 'set-utm',
    ADD_UNIQUE: 'add-unique',
    INCREMENT: 'increment',
  };

  const RECAPTCHA_ACTIONS = {
    EMBEDDED_FORM_SHOWN: 'EMBEDDED_FORM_SHOWN',
    FOOTER_SUBMIT: 'FOOTER_SUBMIT',
    POPUP_SUBMIT: 'POPUP_SUBMIT',
  };
  const RECAPTCHA_ENDPOINTS = {
    [RECAPTCHA_ACTIONS.EMBEDDED_FORM_SHOWN]: '/embedded',
    [RECAPTCHA_ACTIONS.FOOTER_SUBMIT]: '/footer',
    [RECAPTCHA_ACTIONS.POPUP_SUBMIT]: '/popup',
  };

  const BUSINESS_INTELLIGENCE_SERVICE_LOCATION = '/apps/bi';
  const BUSINESS_INTELLIGENCE_SERVICE_API_KEY = 'djqqdbnMT660BAtUF40zPA';
  const BUSINESS_INTELLIGENCE_SERVICE_ENDPOINTS = {
    [EVENT_KEYS.ACCOUNT.PASSWORD_CHANGED]: '/webstore/events',
    [EVENT_KEYS.ACCOUNT.PRIVACY_POLICY_MESSAGE_SEEN]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CANCEL_BACKOUT]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CANCEL_CONFIRMED]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CANCEL_INITIATED]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CANCEL_SAVE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CANCEL_DELAY_SAVE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CHANGE_DATE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.CHANGE_SIZE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.LINE_ITEM_MODIFICATION_RECURRING]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.LINE_ITEM_MODIFICATION_ONETIME]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.RESUMED]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.SCHEDULE_ACCELERATE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.SCHEDULE_DELAY]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.SHIP_NOW_INITIATE]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.SHIP_NOW_CONFIRM]: '/webstore/events',
    [EVENT_KEYS.SUBSCRIPTION.UPDATE_PAYMENT_METHOD]: '/webstore/events',
    // MIGRATED FROM WEB_SDK_EVENTS_BY_KEY
    [EVENT_KEYS.ACCOUNT.REGISTER]: '/webstore/events',
    [EVENT_KEYS.ACCOUNT.LOGIN]: '/webstore/events',
    [EVENT_KEYS.ACCOUNT.UPDATE]: '/webstore/events',
    [WAITLIST_KEYS.CIRKUL_PLUS.REGULAR]: '/webstore/join-waitlist',
    [WAITLIST_KEYS.CIRKUL_PLUS.PRIORITY]: '/webstore/join-waitlist',
  };
  const BUSINESS_INTELLIGENCE_SERVICE_UNAUTHED_ENDPOINTS = {
    [UNAUTHED_EVENT_KEYS.TIKTOK.ADD_TO_CART]: '/webstore/events/tik-tok',
    [UNAUTHED_EVENT_KEYS.TIKTOK.VIEW_CONTENT]: '/webstore/events/tik-tok',
  };
  const BUSINESS_INTELLIGENCE_SERVICE_UPDATE_ENDPOINTS = {
    [PROFILE_UPDATE_ACTIONS.SET]: '/profiles',
    [PROFILE_UPDATE_ACTIONS.SET_ONCE]: '/profiles',
    [PROFILE_UPDATE_ACTIONS.SET_UTM]: '/profiles',
    [PROFILE_UPDATE_ACTIONS.ADD_UNIQUE]: '/profiles',
    [PROFILE_UPDATE_ACTIONS.INCREMENT]: '/profiles',
  };

  const WEB_SDK_EVENTS_BY_KEY = {
    //   [EVENT_KEYS.ACCOUNT.REGISTER]: { type: 'account', action: 'register', heapEventName: 'Account - Register', heapEventVersion: '1', amplitudeEventName: 'Signed Up' },
    //   [EVENT_KEYS.ACCOUNT.LOGIN]: { type: 'account', action: 'login', heapEventName: 'Account - Login', heapEventVersion: '1', amplitudeEventName: 'Logged In' },
    [EVENT_KEYS.ACCOUNT.LOGOUT]: { type: 'account', action: 'logout', heapEventName: 'Account - Logout', heapEventVersion: '1', amplitudeEventName: 'Logged Out' },
    //   [EVENT_KEYS.ACCOUNT.UPDATE]: { type: 'account', action: 'update', heapEventName: 'Account - Update', heapEventVersion: '1' },
    [EVENT_KEYS.LIST.SUBSCRIBE]: { list_id: 'badf1096-b855-4fd1-ad2d-6832e99e8105', type: 'cirkul', action: 'newsletter_subscribe', heapEventName: 'Newsletter - Subscribe', heapEventVersion: '1', amplitudeEventName: 'Newsletter Subscribe' },
        // TODO: Set `action` value to trigger event logging to Amplitude and Iterable (in some cases)
    [EVENT_KEYS.LIST.FREE_SIP_CHOICE]: { supportsLogEventNew: true, action: 'newsletter_free_sip_choice',postscriptEventType: 'Newsletter_FreeSipChoice',  klaviyoEventName: 'Newsletter - Free Sip Choice', amplitudeEventName: 'Newsletter Free Sip Choice' },
    [EVENT_KEYS.SMS.SUBSCRIBE]: { supportsLogEventNew: true, action: 'sms_subscribe', postscriptEventType: 'SMS_Subscribe', klaviyoEventName: 'SMS - Subscribe', amplitudeEventName: 'SMS Subscribe' },
    [EVENT_KEYS.SMS.VERIFY]: { supportsLogEventNew: true, action: 'sms_verify_optin', postscriptEventType: 'SMS_VerifyOptIn', klaviyoEventName: 'SMS - Verify Optin', amplitudeEventName: 'SMS Verify Optin' },
    [EVENT_KEYS.SMS.RESEND_VERIFICATION]: { supportsLogEventNew: true,  action: 'sms_resend_optin', postscriptEventType: 'SMS_ResendOptIn', klaviyoEventName: 'SMS - Resend Optin', amplitudeEventName: 'SMS Resend Optin' },
    [EVENT_KEYS.PRODUCT.DETAIL_VIEW]: { type: 'product', action: 'detail', heapEventName: 'Product - Detail View', heapEventVersion: '1' },
    [EVENT_KEYS.SOCIAL.OUTBOUND_LINK_FOLLOW]: { type: 'social', action: 'outbound_link_follow', heapEventName: 'Social - Outbound Link Follow', heapEventVersion: '1' },
    [EVENT_KEYS.REWARDS.REDEEM_TO_CART]: { supportsLogEventNew: true, action: 'redeem_to_cart', amplitudeEventName: 'MARCTEST: Rewards Redeem to Cart' },
    [EVENT_KEYS.REWARDS.REDEEM_TO_SUBSCRIPTION]: { supportsLogEventNew: true, action: 'redeem_to_subscription', amplitudeEventName: 'MARCTEST: Rewards Redeem to Subscription' },
  };

  window.cirkulServices = window.cirkulServices || {};
  window.cirkulServices.businessIntelligence = {
    EVENT_KEYS: EVENT_KEYS,
    UNAUTHED_EVENT_KEYS: UNAUTHED_EVENT_KEYS,
    PROFILE_UPDATE_ACTIONS: PROFILE_UPDATE_ACTIONS,
    WAITLIST_KEYS: WAITLIST_KEYS,
    RECAPTCHA_ACTIONS: RECAPTCHA_ACTIONS,
    logInvalidCheckout: logInvalidCheckout,
    logEvent: logEvent,
    logEventNew: logEventNew,
    logUnauthedEvent: logUnauthedEvent,
    joinWaitlist: joinWaitlist,
    // setKlaviyoProfileProperties: setKlaviyoProfileProperties, // 2025-04-15 - Klaviyo Retired
    setPostscriptProfileProperties: setPostscriptProfileProperties,
    callPostscriptAcquisitionFunction: callPostscriptAcquisitionFunction,
    submitSurvey: submitSurvey,
    updateProfile: updateProfile,
    clearDeferredUpdateProfile: clearDeferredUpdateProfile,
    deferredUpdateProfile: deferredUpdateProfile,
    verifyRecaptcha: verifyRecaptcha,
  };

  let customerId = null;
  let customerEmail = null;
  let deferredProfileUpdates = {};
  let recaptchaVerified = false;
  let recaptchaFailed = false;

  let utmSource = null;
  let utmMedium = null;
  let utmCampaign = null;
  let utmContent = null;

  _initService();
  window.resolveCirkulServices.businessIntelligence();

  function _initService() {
    const $helperDiv = $('[data-bi-helper]');

    deferredProfileUpdates = JSON.parse(sessionStorage.getItem(BUSINESS_INTELLIGENCE_DEFERRED_PROFILE_UPDATES_LOCAL_VARIABLE)) || {};

    // console.log('MARCTEST DEFERRED PROFILE UPDATES', typeof deferredProfileUpdates, deferredProfileUpdates);

    if (!$helperDiv.length) {
      const previousCustomerId = localStorage.getItem(BUSINESS_INTELLIGENCE_CUSTOMER_ID_LOCAL_VARIABLE);

      if (previousCustomerId) {
        handleLogout();
      }
      return;
    }

    // CODE BELOW THIS LINE WILL NOT EXECUTE IF CUSTOMER NOT LOGGED IN

    customerId = $helperDiv.data('customer-id');
    customerEmail = $helperDiv.data('customer-email');
    _checkSubscriptionStatus();

    // 2025-04-15 - Klaviyo Retired
    // if (customerEmail && window.klaviyo) { // Klaviyo doesn't load on survey pages
    //   window.klaviyo.push(['identify', { '$email': customerEmail }]); // Klaviyo
    // }


    localStorage.setItem(BUSINESS_INTELLIGENCE_CUSTOMER_ID_LOCAL_VARIABLE, customerId);

    utmSource = getUtmParameter('source') || ((getUtmParameter('medium') || getUtmParameter('campaign') || getUtmParameter('content')) ? 'none' : 'direct');
    utmMedium = getUtmParameter('medium') || 'none';
    utmCampaign = getUtmParameter('campaign') || 'none';
    utmContent = getUtmParameter('content') || 'none';

    if (utmSource !== 'direct' || utmMedium !== 'none' ||
      utmCampaign !== 'none' || utmContent !== 'none') {
      updateProfile(PROFILE_UPDATE_ACTIONS.SET_UTM, {
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent
      });
    }

    logDeferredProfileUpdates();
  }

  function logInvalidCheckout(eventData, checkoutToken) {
    const LOGGED_INVALID_CHECKOUT_LOCAL_STORAGE_PREFIX = 'cirkul:logged-and-cleared-invalid-checkout';
    eventData.timestamp = new Date().toISOString();
    eventData.checkoutToken = checkoutToken;

    const alreadyLoggedForToken = localStorage.getItem(`${ LOGGED_INVALID_CHECKOUT_LOCAL_STORAGE_PREFIX }:${ checkoutToken }`);

    if (alreadyLoggedForToken) return;

    localStorage.setItem(`${ LOGGED_INVALID_CHECKOUT_LOCAL_STORAGE_PREFIX }:${ checkoutToken }`, true);

    $.ajax({
      data: JSON.stringify({
        eventData: eventData,
      }),
      headers: {
        'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
        'Content-Type': 'application/json; charset=UTF-8'
      },
      processData: false,
      type: 'POST',
      url: BUSINESS_INTELLIGENCE_SERVICE_LOCATION + '/invco',
      success: (response) => { },
      error: (error) => { },
    });
  }

  function logEvent(eventKey, eventData, extraData) {
    const eventEndpoint = BUSINESS_INTELLIGENCE_SERVICE_ENDPOINTS[eventKey];
    const webSdkEvent = WEB_SDK_EVENTS_BY_KEY[eventKey];
    let webSdkLogAttempts = 0;
    eventData = eventData || {};

    console.log('MARCTEST LOG BI EVENT::', eventKey, customerId, customerEmail);

    return new Promise((resolve, reject) => {
      if (!eventEndpoint && !webSdkEvent) {
        reject({ message: 'Invalid eventKey' });
        return;
      }

      if (eventKey === EVENT_KEYS.ACCOUNT.LOGIN) {
        const timestamp = dayjs().toISOString();

        //customerId = extraData.customerId; // TEST FIX
        customerEmail = extraData.loginEmail;

        deferredUpdateProfile('last_login_at', PROFILE_UPDATE_ACTIONS.SET, {
          last_login_at: timestamp
        });

        deferredUpdateProfile('first_login_at', PROFILE_UPDATE_ACTIONS.SET_ONCE, {
          first_login_at: timestamp
        });

        deferredUpdateProfile('login_count', PROFILE_UPDATE_ACTIONS.INCREMENT, {
          login_count: 1
        });
      }

      if (eventKey === EVENT_KEYS.ACCOUNT.LOGIN || eventKey === EVENT_KEYS.ACCOUNT.REGISTER) {
        customerId = extraData.customerId;
        customerEmail = extraData.loginEmail;
        _checkSubscriptionStatus();
      }

      console.log('MARCTEST LOG BI EVENT FINAL::', eventKey, customerId, customerEmail);


      if (eventEndpoint && (!customerId && !customerEmail)) {
        reject({ message: 'Customer not logged in' });
        return;
      }

      if (eventEndpoint) {
        resolve(_logViaServer());
      } else if (webSdkEvent) {
        resolve(_logViaWebSdk());
      }
    });

    function _logViaServer() {
      console.log('MARCTEST MIGRATION VERSION', MIGRATION_VERSION);

      return new Promise((resolve, reject) => {
        $.ajax({
          data: {
            apiKey: BUSINESS_INTELLIGENCE_SERVICE_API_KEY,
            migrationVersion: MIGRATION_VERSION, // Only needed while migration from MP to Zaius is in progress
            clientMetadata: {
              customerId: customerId,
              customerEmail: customerEmail,
              pageTitle: document.title,
              resolution: `${Math.floor(window.screen.width * window.devicePixelRatio)}x${Math.floor(window.screen.height * window.devicePixelRatio)}`,
              viewport: `${Math.floor(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) * window.devicePixelRatio)}x${Math.floor(Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * window.devicePixelRatio)}`,
              colorDepth: `${window.screen.colorDepth}-bit`,
              utm: {
                source: utmSource,
                medium: utmMedium,
                campaign: utmCampaign,
                content: utmContent
              }
            },
            eventData: eventData,
            eventKey: eventKey,
            extraData: extraData || null,
          },
          processData: true,
          type: 'GET',
          url: BUSINESS_INTELLIGENCE_SERVICE_LOCATION + eventEndpoint,
          // headers: {
          //   'Authorization': `Bearer ${ BUSINESS_INTELLIGENCE_SERVICE_API_KEY }`,
          //   'Content-Type': 'application/json; charset=UTF-8'
          // },
          success: (response) => { },
          error: (error) => { },
          complete: () => {
            resolve();
            _identifyWebSdks();
          },
        });
      });

      function _identifyWebSdks() {
        webSdkLogAttempts++;

        if (eventKey === EVENT_KEYS.ACCOUNT.LOGIN || eventKey === EVENT_KEYS.ACCOUNT.REGISTER) {
          if (!window.amplitude) {
            if (webSdkLogAttempts <= 20) {
              console.log('MARCTEST AMPLITUDE TIMEOUT');
              setTimeout(_identifyWebSdks, 500);
            }
            return;
          }

          const customerId = extraData.customerId;

          if (customerId) {
            window.amplitude.getInstance().setUserId(customerId);
          }

          // 2025-04-15 - Klaviyo Retired
          // if (customerEmail) {
          //   window.klaviyo.push(['identify', { '$email': customerEmail }]); // Klaviyo
          // }
        }
      }
    }

    function _logViaWebSdk() {
      webSdkLogAttempts++;

      if (!window.amplitude) {
        if (webSdkLogAttempts <= 20) {
          setTimeout(_logViaWebSdk, 500);
        }
        return;
      }
      
      // let klaviyoIdentifyPromise = Promise.resolve();

      // IMPORTANT: This block must come BEFORE any other event logging.
      if (webSdkEvent.list_id) {
        eventData['$source'] = eventData['$source'] || 'Custom Form';

        window.waitForCirkulServices.analyticsTags.then(() => {
          try {
            const AnalayticsTagsService = window.cirkulServices.analyticsTags;
            AnalayticsTagsService.logEvent(AnalayticsTagsService.TAG_EVENTS.EMAIL_SUBSCRIBED, { emailAddressSource: eventData['$source'], viaPopup: eventData['via_popup'] });
          } catch (err) { } // Failure to log should not prevent anything else from happening
        });

        console.log('MARCTEST LOG SUBSCRIBE VIA WEB SDK', webSdkEvent.list_id, eventData);
        $.ajax({
          data: {
            email: eventData.email
          },
          type: 'POST',
          url: `https://links.iterable.com/lists/publicAddSubscriberForm?publicIdString=${ webSdkEvent.list_id }`,
          success: (response) => { console.log('MARCTEST ITERABLE NEWSLETTER SUBSCRIBE', response); },
          error: (err) => { console.log('MARCTEST ITERABLE NEWSLETTER ERROR', err.statusCode, err.message); },
        });

        // klaviyoIdentifyPromise = window.klaviyo.identify({ '$email': eventData.email });

        // Change email property to submitted_email for the actual event to be logged in the next step.
        eventData.submitted_email = eventData.email;
        delete eventData.email;
      }

      if (webSdkEvent.action) {
        eventData.client_event_version = webSdkEvent.heapEventVersion;
        console.log('MARCTEST LOG EVENT VIA WEB SDK', webSdkEvent.heapEventName, eventData);

        // Track Amplitude first (currently only used for List Subscribes and Logouts. Most properties are used for List Subscribe)
        if (webSdkEvent.amplitudeEventName) {
          window.amplitude.getInstance().logEvent(webSdkEvent.amplitudeEventName, {
            url: window.location.pathname,
            domain: window.location.host,
            submitted_email: eventData.submitted_email,
            source: eventData['$source'],
            popup_variant: eventData.popup_variant,
            via_popup: eventData.via_popup,
            popup_mode: eventData.popup_mode,
          });
        } else {
          console.log('AMPLITUDE not logging', webSdkEvent);
        }

        // 2025-04-15 - Klaviyo Retired
        // klaviyoIdentifyPromise.then(() => {
        //   window.klaviyo.track(webSdkEvent.heapEventName, eventData);
        // });
      }

      if (eventKey === EVENT_KEYS.ACCOUNT.LOGIN || eventKey === EVENT_KEYS.ACCOUNT.REGISTER) {
        const customerId = extraData.customerId;

        if (customerId) {
          window.amplitude.getInstance().setUserId(customerId);
        }
      }
    }
  }

  // TODO 2024-03-16 - move all events to use this instead of logEvent (better event data handling)
  function logEventNew(eventKey, eventData, extraData) {
    const webSdkEvent = WEB_SDK_EVENTS_BY_KEY[eventKey];
    let webSdkLogAttempts = 0;
    eventData = eventData || {};

    return new Promise((resolve, reject) => {
      if (webSdkEvent && webSdkEvent.supportsLogEventNew) {
        resolve(_logViaWebSdk());
      } else {
        reject({ message: 'Invalid eventKey' });
      }
    });

    function _logViaWebSdk() {
      webSdkLogAttempts++;
      
      return new Promise((resolve, reject) => {
        if (!window.amplitude || !window.postscript) {
          if (webSdkLogAttempts <= 20) {
            setTimeout(() => {
              resolve(_logViaWebSdk())
            }, 500);
          } else {
            reject(new Error('Could not log event - SDKs not loaded'));
          }
          return;
        }

        if (webSdkEvent.action) {
          // Track Amplitude first
          if (webSdkEvent.amplitudeEventName) {
            const amplitudeEventData = JSON.parse(JSON.stringify(eventData));
            amplitudeEventData.url = window.location.pathname,
            amplitudeEventData.domain = window.location.domain,
  
            console.log('MARCTEST LOG EVENT VIA AMPLITUDE SDK', webSdkEvent.amplitudeEventName, amplitudeEventData);
            window.amplitude.getInstance().logEvent(webSdkEvent.amplitudeEventName, amplitudeEventData);
          } else {
            console.log('AMPLITUDE not logging', webSdkEvent);
          }

          // 2025-04-15 - Klaviyo Retired
          // if (webSdkEvent.klaviyoEventName) {
          //   const klaviyoEventData = JSON.parse(JSON.stringify(eventData));
          //   window.klaviyo.track(webSdkEvent.klaviyoEventName, klaviyoEventData);
          // } else {
          //   console.log('KLAVIYO not logging', webSdkEvent);
          // }

          // Then Postscript
          if (webSdkEvent.postscriptEventType) {
            const postscriptEventData = JSON.parse(JSON.stringify(eventData));
            _logPostscriptCustomEvent(webSdkEvent.postscriptEventType, postscriptEventData).catch((err) => {
              console.error('[_logPostscriptCustomEvent] ERROR:', err)
            });
          } else {
            console.log('POSTSCRIPT not logging', webSdkEvent);
          }
        }

        resolve();
      });
    }
  }

  function logUnauthedEvent(eventKey, eventData, eventId) {
    const eventEndpoint = BUSINESS_INTELLIGENCE_SERVICE_UNAUTHED_ENDPOINTS[eventKey];
    eventData = eventData || {};

    const finalEventData = {
      ...eventData,
      event_time: Math.round(eventId / 1000),
      event_id: eventId.toString(),
      context: {
        user: {
          external_id: ((window.amplitude && window.amplitude.getSessionId && window.amplitude.getSessionId()) || '').toString(),
        }
      },
      timestamp: new Date().toISOString(),
    };

    console.log('MARCTEST LOG UNAUTHED BI EVENT::', eventKey, finalEventData);

    return new Promise((resolve, reject) => {
      if (!eventEndpoint) {
        reject({ message: 'Invalid eventKey' });
        return;
      }

      $.ajax({
        data: JSON.stringify({
          eventData: finalEventData,
          eventKey: eventKey,
        }),
        headers: {
          'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
          'Content-Type': 'application/json; charset=UTF-8'
        },
        processData: false,
        type: 'POST',
        url: BUSINESS_INTELLIGENCE_SERVICE_LOCATION + eventEndpoint,
        success: (response) => { },
        error: (error) => { },
        complete: () => {
          resolve();
        },
      });
    });
  }

  function joinWaitlist(waitlistKey, email, customerId) {
    return new Promise((resolve, reject) => {
      const waitlistEndpoint = BUSINESS_INTELLIGENCE_SERVICE_ENDPOINTS[waitlistKey];

      if (!waitlistEndpoint) {
        reject({ message: 'Invalid waitlistKey' });
        return;
      } else if (!email) {
        reject({ message: 'Missing email' });
        return;
      } else if (waitlistKey === WAITLIST_KEYS.CIRKUL_PLUS.PRIORITY && !customerId) {
        reject({ message: 'Missing customerId' });
        return;
      }

      $.ajax({
        data: JSON.stringify({
          waitlistKey: waitlistKey,
          email: email,
          customerId: customerId,
          clientMetadata: {
            customerId: customerId,
            customerEmail: email,
            pageTitle: document.title,
            resolution: `${Math.floor(window.screen.width * window.devicePixelRatio)}x${Math.floor(window.screen.height * window.devicePixelRatio)}`,
            viewport: `${Math.floor(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) * window.devicePixelRatio)}x${Math.floor(Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * window.devicePixelRatio)}`,
            colorDepth: `${window.screen.colorDepth}-bit`,
            utm: {
              source: utmSource,
              medium: utmMedium,
              campaign: utmCampaign,
              content: utmContent
            }
          },
        }),
        headers: {
          'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
          'Content-Type': 'application/json; charset=UTF-8'
        },
        processData: false,
        type: 'POST',
        url: `${ BUSINESS_INTELLIGENCE_SERVICE_LOCATION }${ waitlistEndpoint }`,
        success: (response) => {
          console.log('[2024-11-23] joinWaitlist response:', response);
          resolve({ message: response.message });
        },
        error: (error) => { 
          console.log('[2024-11-23] joinWaitlist error:', error);
          reject({ message: error?.responseJSON?.message });
        },
      });
    });
  }

  // 2025-04-15 - Klaviyo Retired
  // function setKlaviyoProfileProperties(email, properties) {
  //   if (email) {
  //     properties['$email'] = email;
  //     window.klaviyo.identify(properties);
  //   }
  // }

  function setPostscriptProfileProperties(phoneNumber, properties) {
    if (phoneNumber) {
      return new Promise((resolve, reject) => {
        window.postscript.identify({
          phone: phoneNumber,
        }).then(response => {
          const requestBody = {
            phoneNumberE164: phoneNumber, // subscriber ID from front-end can't be used to reference customers in backend API, so provide phone number instead
            properties: properties,
          }
  
          $.ajax({
            data: JSON.stringify(requestBody),
            processData: false,
            type: 'PATCH',
            url: `${BUSINESS_INTELLIGENCE_SERVICE_LOCATION}/postscript/subscriber/update`,
            headers: {
              'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
              'Content-Type': 'application/json; charset=UTF-8'
            },
            success: resolve,
            error: reject,
          });
        }).catch(reject);
      });
    } else {
      return Promise.reject(new Error('phoneNumber required'));
    }
  }

  function callPostscriptAcquisitionFunction(functionName, phoneNumber, functionPayload) {
    if (phoneNumber) {
      return Promise.resolve(
        window.postscript.identify({
          phone: phoneNumber,
        }).then(response => {
          return window.postscript.acquisition[functionName](functionPayload)
              .then(response => {
                return response;
              });
        }).catch(err => {
          return { success: false }; // Mimic Postscript failure response
        })
      );
    } else {
      return Promise.resolve();
    }
  }

  function submitSurvey(surveyKey, submissionData) {
    return new Promise((resolve, reject) => {
      $.ajax({
        data: JSON.stringify(submissionData),
        processData: false,
        type: 'POST',
        url: `${BUSINESS_INTELLIGENCE_SERVICE_LOCATION}/survey/${surveyKey}`,
        headers: {
          'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
          'Content-Type': 'application/json; charset=UTF-8'
        },
        success: resolve,
        error: reject,
      });
    });
  }

  function updateProfile(updateAction, updates, deferKey) {
    const profileEndpoint = BUSINESS_INTELLIGENCE_SERVICE_UPDATE_ENDPOINTS[updateAction];
    const isDirectSet = updateAction === PROFILE_UPDATE_ACTIONS.DIRECT_SET;

    updates = updates || null;

    console.log('MARCTEST UPDATE BI PROFILE ::', updateAction, customerId, customerEmail);

    return new Promise((resolve, reject) => {
      if (!isDirectSet && !profileEndpoint) {
        reject({ message: 'Invalid updateAction' });
        return;
      }

      if (!isDirectSet && (!customerId && !customerEmail)) {
        reject({ message: 'Customer not logged in' });
        return;
      }

      if (isDirectSet) {// Since Klaviyo can't log non-identified customer events
        resolve(_logViaWebSdk());

        // Temporary Zaius/Klaviyo compatibility fixes
        const deferredUpdates = JSON.parse(JSON.stringify(updates));
        delete deferredUpdates.vuid;
        if (deferredUpdates.popup_offer_set_at) {
          deferredUpdates.popup_offer_set_at = dayjs.unix(deferredUpdates.popup_offer_set_at).toISOString();
        }

        if (deferredUpdates.bundle_popup_offer_set_at) {
          deferredUpdates.bundle_popup_offer_set_at = dayjs.unix(deferredUpdates.bundle_popup_offer_set_at).toISOString();
        }

        deferredUpdateProfile(_.keys(deferredUpdates).join('|'), PROFILE_UPDATE_ACTIONS.SET, deferredUpdates);
      } else {
        resolve(_logViaServer());
      }


    });

    function _logViaServer() {
      return new Promise((resolve, reject) => {
        console.log('MARCTEST LOGGING VIA GET');
        $.ajax({
          data: {
            apiKey: BUSINESS_INTELLIGENCE_SERVICE_API_KEY,
            customerId: customerId,
            customerEmail: customerEmail,
            updateAction: updateAction,
            updates: updates
          },
          processData: true,
          type: 'GET',
          url: BUSINESS_INTELLIGENCE_SERVICE_LOCATION + profileEndpoint,
          // headers: {
          //   'Authorization': `Bearer ${ BUSINESS_INTELLIGENCE_SERVICE_API_KEY }`,
          //   'Content-Type': 'application/json; charset=UTF-8'
          // },
          success: (response) => { },
          error: (error) => { },
          complete: resolve
        });

        if (deferKey) {
          // Once the request has been sent, don't resend (done here instead of on success in case browser navigates away before response received)
          clearDeferredUpdateProfile(deferKey);
        }
      });
    }

    function _logViaWebSdk() {
      // Can be deleted. Only logged to Zaius.
    }
  }

  function clearDeferredUpdateProfile(deferKey) {
    delete deferredProfileUpdates[deferKey];

    sessionStorage.setItem(BUSINESS_INTELLIGENCE_DEFERRED_PROFILE_UPDATES_LOCAL_VARIABLE, JSON.stringify(deferredProfileUpdates));
  }

  function deferredUpdateProfile(deferKey, updateAction, updates) {
    deferredProfileUpdates[deferKey] = {
      action: updateAction,
      data: updates,
    };

    // console.log('MARCTEST ADDING DEFERRED UPDATE PROFILE', deferKey, updateAction, updates, JSON.stringify(deferredProfileUpdates));

    sessionStorage.setItem(BUSINESS_INTELLIGENCE_DEFERRED_PROFILE_UPDATES_LOCAL_VARIABLE, JSON.stringify(deferredProfileUpdates));

    logDeferredProfileUpdates(); // Try logging right away if possible
  }

  function logDeferredProfileUpdates() {
    if (customerId) {
      _.forEach(deferredProfileUpdates, (deferredUpdate, deferKey) => {
        if (!deferredUpdate.logAfterSubscriptionCheckout && !deferredUpdate.logTriggerKey) {
          // console.log('MARCTEST PROCESS DEFERRED UPDATE', deferredUpdate.action, deferredUpdate.data);
          updateProfile(deferredUpdate.action, deferredUpdate.data, deferKey);
        }
      });
    }
  }

  function handleLogout() {
    if (!window.amplitude) {
      setTimeout(handleLogout, 500);
      return;
    }

    localStorage.removeItem(BUSINESS_INTELLIGENCE_CUSTOMER_ID_LOCAL_VARIABLE);

    logEvent(EVENT_KEYS.ACCOUNT.LOGOUT, null);

    window.amplitude.getInstance().setUserId(null);
    window.amplitude.getInstance().regenerateDeviceId();
  }

  function getUtmParameter(parameterName) {
    return getParameterByName(`utm_${parameterName}`);
  }

  // Courtesy of https://stackoverflow.com/a/901144
  function getParameterByName(name, url) {
    /* eslint-disable */
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
    /* eslint-enable */
  }

  function _logPostscriptCustomEvent(eventType, properties) {
    if (!properties.phone) {
      return Promise.reject(new Error('Missing properties.phone'))
    } else if (!eventType) {
      return Promise.reject(new Error('Missing eventType'))
    }

    return new Promise((resolve, reject) => {
      const requestBody = {
        eventType: eventType,
        phoneNumberE164: properties.phone, // subscriber ID from front-end can't be used to reference customers in backend API, so provide phone number instead
        properties: _.omit(properties, 'phone'),
      }

      $.ajax({
        data: JSON.stringify(requestBody),
        processData: false,
        type: 'POST',
        url: `${BUSINESS_INTELLIGENCE_SERVICE_LOCATION}/postscript/event/log/phone`,
        headers: {
          'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
          'Content-Type': 'application/json; charset=UTF-8'
        },
        success: resolve,
        error: reject,
      });
    });
  }

  function _checkSubscriptionStatus() {
    window.waitForCirkulServices.subscriptions.then(() => {
      window.cirkulServices.subscriptions.hasSubscription(customerId)
        .then((hasSubscription) => {
          if (hasSubscription) {
            localStorage.setItem(HAS_SUBSCRIPTION_LOCAL_VARIABLE, true); // USED FOR SITEWIDE CART. Should not be unset, to prevent multiple subscription abuse.
          }
        });
    });
  }

  function verifyRecaptcha(recaptchaAction, passedCallback, failedCallback) {    
    if (recaptchaFailed || !RECAPTCHA_ENDPOINTS[recaptchaAction]) {
      failedCallback();
    } else if (recaptchaVerified) {
      passedCallback();
    } else {
      try {
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute('6LeRHTIqAAAAAIYeEyV1akkoln4hb7jhUa1Odk6l', { action: recaptchaAction });
  
          $.ajax({
            data: JSON.stringify({ rt: token }),
            processData: false,
            type: 'POST',
            url: `${BUSINESS_INTELLIGENCE_SERVICE_LOCATION}${ RECAPTCHA_ENDPOINTS[recaptchaAction] }`,
            headers: {
              'Authorization': `Bearer ${BUSINESS_INTELLIGENCE_SERVICE_API_KEY}`,
              'Content-Type': 'application/json; charset=UTF-8'
            },
            success: (response) => {
              if (response.fail) {
                recaptchaFailed = true;
                failedCallback();
              } else {
                recaptchaVerified = true;
                passedCallback();
              }
            },
            error: (err) => {
              recaptchaFailed = true;
              failedCallback();
            },
          });
        });
      } catch(err) {
        // If failed to generate a token, still allow another attempt to be made.
        failedCallback(); 
      }
    }
  }
})();
